import { PersistConfig, PersistedState, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { AccountSlice, AccountState } from '../types';

const isAccountSlice = (
  state: unknown,
): state is AccountSlice & PersistedState =>
  typeof state === 'object' && state !== null;

// API credentials must not sit in localStorage where any XSS can read them;
// they are re-fetched after sign-in
const stripTokens = createTransform<AccountState, AccountState>(
  inboundState => ({
    ...inboundState,
    userEndpointToken: undefined,
    workerToken: undefined,
  }),
  outboundState => outboundState,
);

export const accountPersistConfig: PersistConfig<AccountSlice> = {
  key: 'account',
  storage,
  transforms: [stripTokens],
  migrate: async state => {
    if (isAccountSlice(state)) {
      return Object.fromEntries(
        Object.entries(state).map(([key, value]) => {
          if ('isWorkerAuthorized' in value) {
            value.isWorkerAuthorized = false;
          }

          return [key, value];
        }),
      ) as AccountSlice & PersistedState;
    }

    return state;
  },
};
